import { QueryDocumentSnapshot, snapToData } from '@angular/fire/firestore';
import { FormControl, FormGroup } from "@angular/forms";

export type BindingForm = FormGroup<{
  id: FormControl<string>;
  erpId: FormControl<string>;
  description: FormControl<string>;
  organizationId: FormControl<string>;
}>

export class Binding {
  id: string;
  erpId: string;
  description: string;
  organizationId: string;

  constructor(data?: Partial<Binding>) {
    this.id = data?.id ?? '';
    this.erpId = data?.erpId ?? '';
    this.description = data?.description ?? '';
    this.organizationId = data?.organizationId ?? '';
  }

  static toFirestore(binding: Binding): Binding {
    return {
      id: binding.id,
      erpId: binding.erpId,
      description: binding.description,
      organizationId: binding.organizationId,
    };
  }

  static fromFirestore(snapshot: QueryDocumentSnapshot): Binding {
    return new Binding(snapToData(snapshot, { idField: 'id' }));
  }
}
